import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const uploadStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: false,
  title: `quote:files.title`,
  additionalCopy: `quote:additionalCopy.files.title`,
  segmentEvent: `Photo Uploaded`,
  fields: [
    {
      type: ServiceRequestFieldType.UPLOAD,
      summaryTitle: `file`,
      props: {
        name: `file`,
        placeholder: `quote:files.placeholder`,
      },
    },
  ],
};
